export default __webpack_public_path__ + "static/media/L0005.e8449ee7.png";